<template>
    <v-container pt-5 fluid style="color:black" class="policeLato">
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl id="histoire">
            <!-- image de l'entete -->
           <!-- <v-layout>
                <v-flex>
                    <v-img :src="require('../assets/img/apropos/apropos.png')"></v-img>
                </v-flex>
            </v-layout>-->
            <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
            <section>
                <div class="mt-5 paralax-cover-image has-background-dim">
                    <div class="paralax-cover-image-text">
                    <div class="content_home" style="z-index: 1!important;">
                        <h1 style="text-align:left;font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('apropos.header_title[0]') }}</span></h1>
                        <h1 style="text-align:left;font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('apropos.header_title[1]') }}</span></h1>
                    </div>
                </div>
                </div>
            </section>

            <v-layout row wrap class="column">
                <v-flex xs12 sm12 md12 lg12 pa-2 style="background-color: #f5f6f6;">
                    <div class="justify-content-center column pt-5">
                        <div class="justify-content-center row">
                            <h1 class="justify-content-center row titre_for_desktop">{{ $t('apropos.history_title') }}</h1>
                        </div>
                        <div class="justify-content-center row mt-2">
                            <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                        </div>
                    </div>
                </v-flex>
                <!---- ================ WEB ================== -->
                <v-layout style="background-color: #f5f6f6">
                    <v-flex xs7 style="padding-left: 7%">
                        <div class="justify-content-center row mb-5" id="faq">
                            <div class="pa-5 text-justify subheading font-weight-blod pl-md-5 pr-md-5" style="margin-bottom:-50px">
                                {{ $t('apropos.history_content[0]') }}<br><br>
                                {{ $t('apropos.history_content[1]') }} <br>
                                <span class="body-4 font-weight-bold policeLato" style="color:#ffa409">{{ $t('apropos.history_content[2]') }}</span>
                            </div>
                        </div>
                    </v-flex>
                    <div class="mb-5">
                        <v-divider vertical></v-divider>
                    </div>
                    <v-flex style="padding-right: 8%">
                        <ul class="expansion expand-list ml-3 mr-3">
                            <li data-md-content="200" class="mb-3"><v-img style="margin-top: -10px;margin-bottom: -20px" height="300" :src="require('../assets/img/apropos/assuraf_banner_2.jpg')" class="border-radius">
                            <span @click="dialog = true" class="justify-content-center row" style="color: #fff;margin-top: 23%;cursor: pointer;">
                                <img
                                    fetchpriority="low"
                                    width="100"
                                    src="../assets/img/play_video.png"
                                    alt="Lire la vidéo"
                                    role="button"
                                    tabindex="0"
                                    aria-label="Lire la vidéo"
                                    loading="lazy"
                                    @keydown.enter="$emit('click')"
                                    @keydown.space.prevent="$emit('click')"
                                />
                            </span>
                        </v-img></li>
                        </ul>
                    </v-flex>
                </v-layout>
               
                <!-- Partie Quelques chiffres-->
                <v-layout class="mt-3">
                    <v-flex style="background-color: #ffa409">
                        <div class="justify-content-center column pt-5">
                            <div class="justify-content-center row">
                                <h1 class="justify-content-center row titre_for_desktop">{{ $t('apropos.data_title') }}</h1>
                            </div>
                            <div class="justify-content-center row mt-2">
                                <v-toolbar class="justify-content-center row underline_bar_for_number"></v-toolbar>
                            </div>
                        </div>
                            <div class="pt-4" style="padding-left: 10.5%;padding-right:10.5%">
                                 <StatSection></StatSection>
                            </div>
                    </v-flex>
                </v-layout>

                <!-- Partie Notres ambitions-->
                <v-layout class="mt-3">
                    <v-flex style="background-color: #f5f6f6">
                        <div class="justify-content-center column pt-5">
                            <div class="justify-content-center row">
                                <h1 class="justify-content-center row titre_for_desktop">{{ $t('apropos.ambition_title') }}</h1>
                            </div>
                            <div class="justify-content-center row mt-2">
                                <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                            </div>
                        </div>
                        <v-layout class="justify-content-center row mt-5 mb-5" id="valeurs">
                            <v-flex xs12 sm12 md12 lg12>
                                <p class="headline policeLato font-weight-regular text-center pb-3">
                                    <span style="color:#ffa409;font-weight:bold;font-size:30px;">“</span>
                                    {{ $t('apropos.ambition_content[0]') }}<br>
                                    {{ $t('apropos.ambition_content[1]') }}
                                    <span style="color:#ffa409;font-weight:bold;font-size:30px;">”</span>
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

                <!-- Partie Nos Valeurs-->
                <v-layout>
                    <v-flex style="background-color: #f5f6f6">
                        <!--<h1 class="mt-3 policeLato font-weight-bold row justify-content-center" style="font-size:28px;color:#59595B">NOS VALEURS</h1>-->
                        <div class="justify-content-center column pt-5">
                            <div class="justify-content-center row">
                                <h1 class="justify-content-center row titre_for_desktop">{{ $t('apropos.valeurs_title') }}</h1>
                            </div>
                            <div class="justify-content-center row mt-2">
                                <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                            </div>
                        </div>
                        <v-layout class="justify-content-center row mb-5">
                            <div style="padding-left: 10%;padding-right:10%">
                                <!--pour les tabs-->
                                <v-tabs v-model="tabs" centered slider-color="#ffa409" height="75" grow class="mt-2 policeLato" color="#f5f6f6">
                                    <v-tab href="" class="primary--text" @click="tabinovclicked(item)">
                                        <v-text class="policeLato" style="color: black">{{ $t('apropos.innovation_title') }}</v-text>
                                    </v-tab>
                                    <v-tab href="" class="primary--text" @click="tabengclicked(item)">
                                        <v-text class="policeLato" style="color: black">{{ $t('apropos.engagement_title') }}</v-text>
                                    </v-tab>
                                    <v-tab href="" class="primary--text" @click="tabresclicked(item)">
                                        <v-text class="policeLato" style="color: black">{{ $t('apropos.responsabilite_title') }}</v-text>
                                    </v-tab>
                                </v-tabs>
                                <!--affichage des contenu-->
                                <v-tabs-items class="white">
                                    <v-tab-item>
                                        <v-container class="mt-5 text-justify" style="background-color: #f5f6f6" >
                                            <div style="background-color: #f5f6f6" class="subheading">
                                                <v-text v-if="HideDive" class="policeLato">
                                                    {{ $t('apropos.innovation_content[0]') }}
</v-text>
                                                <v-text v-if="HideDive1" class="policeLato">
                                                    {{ $t('apropos.engagement_content[0]') }}
                                                </v-text>
                                                <v-text v-if="HideDive2" class="policeLato">
                                                    {{ $t('apropos.responsabilite_content[0]') }}
                                                </v-text>
                                            </div>
                                        </v-container>
                                    </v-tab-item>
                                </v-tabs-items>
                            </div>
                        </v-layout>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <!-- FAQ SECTION -->
                   <FaqSection></FaqSection>
                </v-layout>

                <v-layout>
                    <v-flex>
                        <!--PARITE NEWSLETTER-->
                        <div style="background: rgba(153,153,153,0.39);height: 120px" class="mb-5">
                            <div class="row" style="margin-left: 10.5%">
                                <div class="mt-5 justify-content-center row">
                                    <h1 class="justify-content-center" style="color: #001b19;font-size: 25px;font-weight: bold;margin-top: 6%;text-align: center">{{ $t('home_page.newsletter_title') }}</h1>
                                    <a href="https://www.221assurances.com" target="_blank">
                                        <img class="mt-1 ml-4" src="../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
                                    </a>
                                </div>

                                <div class="mt-5 justify-content-center row" style="width: 50%;margin-left: -3%">
                                    <input v-model="UserEmail" type="email" name="email" id="email_input" :placeholder="$t('home_page.newsletter_input_placeholder')">
                                </div>
                                <div class="mt-5 justify-content-center row" style="margin-left: -5%">
                                    <button style="height: 50px!important" flat class="newsletter ml-2" @click="suscribeNewsletter221()">
                                        <span class="newsletter">{{ $t('home_page.newsletter_bouton') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex>
                        <!--PARITE PAIEMENT-->
                        <div style="background: #ffffff;height: 50px;">
                            <div>
                                <div class="justify-content-center row" style="float: left;margin-left: 8%">
                                    <div class="trigger ml-3" style="z-index: 1;">
                                        <span>
                                                                      <img class="mr-3" loading="lazy" src="../assets/img/writing.png" width="25px"  alt="writing quotes">

                                        <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                                        {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                                                    class="ml-4 fas fa-chevron-down"></i></span>
                                        <ul class="devis elevation-24">
                                        <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.particulier_label') }}</li>
                                        <li><a href="/devis/auto"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/cars_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
                                            {{ $t('home_page.bouton_devis[1]') }}</a></li>
                                        <li><a href="/devis/habitation"><i><img class="mr-2" width="35"
                                                                                src="../assets/img/icones/menu/house_quote.png"
                                                                                :alt="$t('home_page.bouton_devis[2]')"/></i>
                                            {{ $t('home_page.bouton_devis[2]') }}</a></li>
                                        <li><a href="/devis/voyage"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/travel_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                                            $t('home_page.bouton_devis[3]')
                                            }}</a></li>
                                        <li><a href="/devis/sante"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/health_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                                            $t('home_page.bouton_devis[4]')
                                            }}</a></li>
                                        <li><a href="/devis/vie"><i><img class="mr-2" width="35"
                                                                        src="../assets/img/icones/menu/life_quote.png"
                                                                        :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                                            $t('home_page.bouton_devis[5]')
                                            }}</a></li>
                                        <li><a href="/plus"><i><img class="mr-2" width="35" src="../assets/img/icones/menu/add_quote.png"
                                                                    :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                                            $t('home_page.bouton_devis[6]')
                                            }}</a></li>
                                        <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.entreprise_label') }}</li>
                                          <li><a href="/flotte/entreprise"><i><img class="mr-2" width="35" src="../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
                                        <li><a href="/devis/mrp"><i><img class="mr-2" width="30"
                                                                        src="../assets/img/icones/menu/mrp_quote.png"
                                                                        alt="devis_mrp"/></i> MRP</a></li>
                                        <li><a href="/devis/trc"><i><img class="mr-2" width="35"
                                                                        src="../assets/img/icones/menu/trc_quote.png"
                                                                        alt="devis_trc"/></i>TRC</a></li>
                                                                        <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
                                        </ul>
                                    </div>

                                    <div class="trigger-simulation ml-4" style="z-index: 1;">
                                        <span>
                                                                      <img class="mr-3" loading="lazy" src="../assets/img/rocket.png" width="25px"  alt="writing quotes">

                                        <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                                        {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                                                    class="ml-4 fas fa-chevron-down"></i></span>
                                        <ul class="devis elevation-24">
                                        <li><a href="/simulate/devis/auto"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/cars_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
                                            {{ $t('home_page.bouton_devis[1]') }}</a></li>
                                        <li><a href="/simulate/devis/voyage"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/travel_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                                            $t('home_page.bouton_devis[3]')
                                            }}</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="justify-content-center row" style="float: right;margin-right: 10%;margin-top: 10px">
                                    <div class="justify-content-center row border-radius logo-paiement">
                                        <img width="60px" height="30px" alt="orange-money-logo" src="../assets/img/logoPaiement/orange-money.png"/>
                                        <img width="60" height="30" alt="free-money-logo" src="../assets/img/logoPaiement/freemoney.png"/>
                                        <img class="pt-1" width="60" height="25" alt="visa-logo" src="../assets/img/logoPaiement/visa.png"/>
                                        <img class="ml-2" width="60" height="30" alt="master-card-logo" src="../assets/img/logoPaiement/master-card.png"/>
                                        <img class="ml-2" width="30" height="30" alt="wave-logo" src="../assets/img/logoPaiement/wave.png"/>
                                        <img class="ml-3" width="30" height="30" alt="kpay-logo" src="../assets/img/logoPaiement/kpay_logo.webp"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-layout>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs>
            <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
            <section v-if="isMobile()">
                <div class="paralax-cover-image_mobile has-background-dim_mobile">
                    <p class="paralax-cover-image-text_mobile">
                    <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                        <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('apropos.header_title[0]') }}</span></h1>
                        <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('apropos.header_title[1]') }}</span></h1>
                    </div>
                    </p>
                </div>
            </section>
            <div class="justify-content-center row" style="background-color: #f5f6f6;">
                <div class="justify-content-center column pt-5">
                    <div class="justify-content-center row">
                        <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('apropos.history_title') }}</h1>
                    </div>
                    <div class="justify-content-center row">
                        <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                    </div>
                </div>
            </div>
            <!--Notre histoire-->
            <v-layout style="background-color: #f5f6f6;">
                <!---- ================ MOBILE ================== -->
                <div class="pl-3 pr-3 pt-3 row">

                    <div class="col-sm-11 pa-4 text-justify subheading font-weight-regular">
                        {{ $t('apropos.history_content[0]') }}
                        <v-btn v-if="isMobile()" @click="toggle()" flat small class="right font-weight-bold" ref="btnPlus" style="color:#ffa409;margin-top:-2px;text-transform: none">Voir Plus</v-btn>

                    </div>
                </div>
            </v-layout>

            <v-layout style="background-color: #f5f6f6;" v-show="!isHidden">
                <div class="pl-3 pr-3 row" style="margin-top: -10%">
                    <div class="col-sm-11 pa-4 text-justify subheading font-weight-regular mt-4">{{ $t('apropos.history_content[1]') }}<br>
                        <span class="body-2 policeLato" style="color:#ffa409;">{{ $t('apropos.history_content[2]') }}</span>
                    </div>
                </div>
            </v-layout>

            <div style="background-color: #f5f6f6;">
                <div class="pb-5">
                    <ul class="expansion expand-list ml-4 mr-4">
                        <li data-md-content="200" class="mb-3"><v-img style="margin-top: -40px;margin-bottom: -20px" height="300" :src="require('../assets/img/apropos/assuraf_banner_2.jpg')" class="border-radius">
                            <span @click="dialog = true" class="justify-content-center row" style="color: #fff;margin-top: 30%;">
                                <img width="80" src="../assets/img/play_video.png" alt="play_video">
                            </span>
                        </v-img></li>

                     
                    </ul>
                </div>
            </div>

            <div class="mt-3">
                    <div class="video-player" style="height: 100%!important">
                        <v-dialog width="800" v-model="dialog" persistent class="modal-video" v-if="isDesktop()">  
                            <v-card id="card-video" class="border-radius">
                            <v-toolbar>
                                <v-spacer></v-spacer>
                                <v-btn icon dark flat @click="VideoManager" class="float-lg-right">
                                <v-icon color="red">&#xe5cd;</v-icon>
                                </v-btn>
                            </v-toolbar>

                            <v-card-text>
                                <v-container>
                                <v-layout wrap>
                                    <v-flex xs12 md12 sm12>
                                    <vue-plyr style="border-radius:20px ">
                                        <!-- //https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/ -->
                                        <video ref="theVideo" controls controlslist="nodownload" id="AssurafVideo" poster="poster.png" src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/VideoFr.mp4" style="width: 100%!important;border-radius: 10px;">
                                        <!-- <source src="../assets/videos/VideoFr.mp4" type="video/mp4" size="720">
                                        <source src="../assets/videos/VideoFr.mp4" type="video/mp4" size="1080"> -->
                                         <source src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/VideoFr.mp4" type="video/mp4" size="720">
                                        <source src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/VideoFr.mp4" type="video/mp4" size="1080">
                                        <track kind="captions" label="English" srclang="en" src="captions-en.vtt" default>
                                        </video>
                                    </vue-plyr>
                                    </v-flex>
                                </v-layout>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-btn color="blue darken-1" flat @click="switchToWolof">
                                <span class="pr-2" style="color:#ffa409">{{ $t('home_page.wolof_video_bouton_label') }} </span>
                                <img src="../assets/img/flagSenegal.png" alt="assuraf video wolof" width="25">
                                </v-btn>
                            </v-card-actions>
                            </v-card>

                            
                            <v-fab-transition>
                            <v-dialog width="800" v-model="dialog2" persistent class="modal-video">
                                <v-card id="card-video-wolof" class="border-radius">
                                <v-toolbar>
                                    <v-spacer></v-spacer>
                                    <v-btn icon dark flat @click="VideoManagerWolof" class="float-lg-right">
                                    <v-icon color="red">&#xe5cd;</v-icon>
                                    </v-btn>
                                </v-toolbar>

                                <v-card-text>
                                    <v-container>
                                    <v-layout wrap>
                                        <vue-plyr>
                                        <video ref="theVideoWolof" controls controlslist="nodownload" id="AssurafVideo2" poster="poster.png" src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/Assuraf_video_Wolof.mp4" style="width: 100%!important;border-radius: 10px;">
                                            <source src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/Assuraf_video_Wolof.mp4" type="video/mp4"
                                                    size="720">
                                            <source src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/Assuraf_video_Wolof.mp4" type="video/mp4"
                                                    size="1080">
                                            <track kind="captions" label="English" srclang="en" src="captions-en.vtt"
                                                default>
                                        </video>
                                        </vue-plyr>
                                    </v-layout>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-btn color="blue darken-1" flat @click="switchToFrench">
                                    <span class="pr-2" style="color:#ffa409">{{ $t('home_page.french_video_bouton_label') }} </span>
                                    <img src="../assets/img/flag-Fr.png" alt="flag fr" width="25">
                                    </v-btn>
                                </v-card-actions>
                                </v-card>
                            </v-dialog>
                            </v-fab-transition>
                        </v-dialog>
                      <v-dialog v-model="dialog" persistent class="modal-video" v-if="isMobile()">  
                        <v-card id="card-video" class="border-radius">
                          <v-toolbar>
                            <v-spacer></v-spacer>
                            <v-btn icon dark flat @click="VideoManager" class="float-lg-right">
                              <v-icon color="red">&#xe5cd;</v-icon>
                            </v-btn>
                          </v-toolbar>

                          <v-card-text>
                            <v-container>
                              <v-layout wrap>
                                <v-flex xs12 md12 sm12>
                                  <vue-plyr style="border-radius:20px ">
                                    <video ref="theVideo" controls controlslist="nodownload" id="AssurafVideo" poster="poster.png" src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/VideoFr.mp4" style="width: 100%!important;border-radius: 10px;">
                                      <source src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/VideoFr.mp4" type="video/mp4" size="720">
                                      <source src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/VideoFr.mp4" type="video/mp4" size="1080">
                                      <track kind="captions" label="English" srclang="en" src="captions-en.vtt" default>
                                    </video>
                                  </vue-plyr>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-btn color="blue darken-1" flat @click="switchToWolof">
                              <span class="pr-2" style="color:#ffa409">{{ $t('home_page.wolof_video_bouton_label') }} </span>
                              <img src="../assets/img/flagSenegal.png" alt="assuraf video wolof" width="25">
                            </v-btn>
                          </v-card-actions>
                        </v-card>

                        
                        <v-fab-transition>
                          <v-dialog v-model="dialog2" persistent class="modal-video">
                            <v-card id="card-video-wolof" class="border-radius">
                              <v-toolbar>
                                <v-spacer></v-spacer>
                                <v-btn icon dark flat @click="VideoManagerWolof" class="float-lg-right">
                                  <v-icon color="red">&#xe5cd;</v-icon>
                                </v-btn>
                              </v-toolbar>

                              <v-card-text>
                                <v-container>
                                  <v-layout wrap>
                                    <vue-plyr>
                                      <video ref="theVideoWolof" controls controlslist="nodownload" id="AssurafVideo2" poster="poster.png" src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/Assuraf_video_Wolof.mp4" style="width: 100%!important;border-radius: 10px;">
                                        <source src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/Assuraf_video_Wolof.mp4" type="video/mp4"
                                                size="720">
                                        <source src="https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/video/Assuraf_video_Wolof.mp4" type="video/mp4"
                                                size="1080">
                                        <track kind="captions" label="English" srclang="en" src="captions-en.vtt"
                                               default>
                                      </video>
                                    </vue-plyr>
                                  </v-layout>
                                </v-container>
                              </v-card-text>

                              <v-card-actions>
                                <v-btn color="blue darken-1" flat @click="switchToFrench">
                                  <span class="pr-2" style="color:#ffa409">{{ $t('home_page.french_video_bouton_label') }} </span>
                                  <img src="../assets/img/flag-Fr.png" alt="flag fr" width="25">
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-fab-transition>
                      </v-dialog>
                    </div>
                  </div>

            <div style="background:#ffa409;height: auto" class="mt-3 mb-3">
                <div class="justify-content-center column pt-5">
                    <div class="justify-content-center row">
                        <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('apropos.data_title') }}</h1>
                    </div>
                    <div class="justify-content-center row">
                        <v-toolbar class="justify-content-center row underline_bar" style="background-color: #fff"></v-toolbar>
                    </div>
                </div>
                <v-layout class="pt-5 pb-5">
                     <StatSectionMobile></StatSectionMobile>
                  
                </v-layout>
            </div>

            <div style="background-color: #f5f6f6;height: auto">
                <div class="justify-content-center column pt-5">
                    <div class="justify-content-center row">
                        <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('apropos.ambition_title') }}</h1>
                    </div>
                    <div class="justify-content-center row">
                        <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                    </div>
                </div>

                <div class="title col-sm-11 pa-4 text-justify subheading font-weight-blod">
                    <p><span style="color:#ffa409;font-size:20px">“</span> {{ $t('apropos.ambition_content[0]') }}<br>
                        {{ $t('apropos.ambition_content[1]') }} <span style="color:#ffa409;font-size:20px">”</span></p>
                </div>
            </div>


            <div style="background-color: #f5f6f6;height: auto">
                <div class="justify-content-center column pt-5">
                    <div class="justify-content-center row">
                        <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('apropos.valeurs_title') }}</h1>
                    </div>
                    <div class="justify-content-center row">
                        <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                    </div>
                </div>
                <div class="pb-5 pt-4">
                    <ul class="expansion expand-list ml-4 mr-4">
                        <li data-md-content="900" class="mt-3">
                            <label name="tab" for="tab2" tabindex="-1" class="tab_lab" role="tab" style="color: #ffa409">{{ $t('apropos.innovation_title') }}</label>
                            <input type="checkbox" class="tab" id="tab2" tabindex="0" />
                            <span style="color: #ffa409" class="open-close-icon"><i class="fas fa-chevron-down"></i><i class="fas fa-chevron-up"></i></span>
                            <div class="content">
                                {{ $t('apropos.innovation_content[0]') }}
                            </div>
                        </li>

                        <li data-md-content="900" class="mt-3">
                            <label name="tab" for="tab2" tabindex="-1" class="tab_lab" role="tab" style="color: #ffa409">{{ $t('apropos.engagement_title') }}</label>
                            <input type="checkbox" class="tab" id="tab2" tabindex="0" />
                            <span style="color: #ffa409" class="open-close-icon"><i class="fas fa-chevron-down"></i><i class="fas fa-chevron-up"></i></span>
                            <div class="content">
                                {{ $t('apropos.engagement_content[0]') }}
                            </div>
                        </li>

                        <li data-md-content="900" class="mt-3 mb-3">
                            <label name="tab" for="tab2" tabindex="-1" class="tab_lab" role="tab" style="color: #ffa409">{{ $t('apropos.responsabilite_title') }}</label>
                            <input type="checkbox" class="tab" id="tab2" tabindex="0" />
                            <span style="color: #ffa409" class="open-close-icon"><i class="fas fa-chevron-down"></i><i class="fas fa-chevron-up"></i></span>
                            <div class="content">
                                {{ $t('apropos.responsabilite_content[0]') }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

              <v-layout>
                    <!-- FAQ SECTION -->
                   <FaqSectionMobile></FaqSectionMobile>
                </v-layout>

            

            <!--PARITE NEWSLETTER-->
            <v-layout>
                <div style="background: rgba(153,153,153,0.39);height:auto;width: 100%">
                    <div class="justify-content-center column">
                        <div class="pt-5 justify-content-center row">
                            <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('home_page.newsletter_title') }}</h1>
                        </div>

                        <div class="justify-content-center row">
              <a href="https://www.221assurances.com" target="_blank">
                <img class="mt-3 mb-4" src="../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
                </a>
            </div>

                        <div class="mt-2 justify-content-center row">
                            <input v-model="UserEmail" type="email" name="email" id="email_input" :placeholder="$t('home_page.newsletter_input_placeholder')">
                        </div>

                        <div class="justify-content-center row pb-5">
                            <button style="height: 50px!important" flat class="newsletter ml-2" @click="suscribeNewsletter221()">
                                <span class="newsletter">{{ $t('home_page.newsletter_bouton') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </v-layout>

            <!--PARITE PAIEMENT-->
            <v-layout>
                <div style="background: #ffffff;height:auto;width: 100%">
                    <div class="column pb-5 pt-5" style="z-index: 1!important;">
                        <div class="justify-content-center row">
                                    <div class="trigger" style="z-index: 2;position: relative;">
                                        <span>
                                                                      <img class="mr-3" loading="lazy" src="../assets/img/writing.png" width="25px"  alt="writing quotes">

                                        <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                                        {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                                                    class="ml-4 fas fa-chevron-down"></i></span>
                                        <ul class="devis elevation-24">
                                        <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.particulier_label') }}</li>
                                        <li><a href="/devis/auto"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/cars_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
                                            {{ $t('home_page.bouton_devis[1]') }}</a></li>
                                        <li><a href="/devis/habitation"><i><img class="mr-2" width="35"
                                                                                src="../assets/img/icones/menu/house_quote.png"
                                                                                :alt="$t('home_page.bouton_devis[2]')"/></i>
                                            {{ $t('home_page.bouton_devis[2]') }}</a></li>
                                        <li><a href="/devis/voyage"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/travel_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                                            $t('home_page.bouton_devis[3]')
                                            }}</a></li>
                                        <li><a href="/devis/sante"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/health_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                                            $t('home_page.bouton_devis[4]')
                                            }}</a></li>
                                        <li><a href="/devis/vie"><i><img class="mr-2" width="35"
                                                                        src="../assets/img/icones/menu/life_quote.png"
                                                                        :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                                            $t('home_page.bouton_devis[5]')
                                            }}</a></li>
                                        <li><a href="/plus"><i><img class="mr-2" width="35" src="../assets/img/icones/menu/add_quote.png"
                                                                    :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                                            $t('home_page.bouton_devis[6]')
                                            }}</a></li>
                                        <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.entreprise_label') }}</li>
                                          <li><a href="/flotte/entreprise"><i><img class="mr-2" width="30" src="../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
                                        <li><a href="/devis/mrp"><i><img class="mr-2" width="30"
                                                                        src="../assets/img/icones/menu/mrp_quote.png"
                                                                        alt="devis_mrp"/></i> MRP</a></li>
                                        <li><a href="/devis/trc"><i><img class="mr-2" width="35"
                                                                        src="../assets/img/icones/menu/trc_quote.png"
                                                                        alt="devis_trc"/></i>TRC</a></li>
                                                                        <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="justify-content-center row">
                                    <div class="trigger-simulation mt-4" style="z-index: 1;position: relative;">
                                        <span>
                                                                      <img class="mr-3" loading="lazy" src="../assets/img/rocket.png" width="25px"  alt="writing quotes">

                                        <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                                        {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                                                    class="ml-4 fas fa-chevron-down"></i></span>
                                        <ul class="devis elevation-24">
                                        <li><a href="/simulate/devis/auto"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/cars_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
                                            {{ $t('home_page.bouton_devis[1]') }}</a></li>
                                        <li><a href="/simulate/devis/voyage"><i><img class="mr-2" width="35"
                                                                            src="../assets/img/icones/menu/travel_quote.png"
                                                                            :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                                            $t('home_page.bouton_devis[3]')
                                            }}</a></li>
                                        </ul>
                                    </div>
                                </div>

                        <div class="justify-content-center row mt-3" style="z-index: 1!important;">
                            <div class="justify-content-center row border-radius logo-paiement mt-2">
                                <img width="50" height="30" alt="orange-money-senegal" src="../assets/img/logoPaiement/orange-money.png"/>
                                <img width="60" height="30" alt="free-money-logo" src="../assets/img/logoPaiement/freemoney.png"/>
                                <img class="pt-1" width="60" height="25" alt="visa-logo" src="../assets/img/logoPaiement/visa.png"/>
                                <img class="ml-1" width="60" height="30" alt="master-card-logo" src="../assets/img/logoPaiement/master-card.png"/>
                                <img class="ml-2" width="30" height="30" alt="wave-logo" src="../assets/img/logoPaiement/wave.png"/>
                                <img class="ml-3" width="30" height="30" alt="kpay-logo" src="../assets/img/logoPaiement/kpay_logo.webp"/>
                            </div>
                        </div>
                    </div>
                </div>
            </v-layout>

        </div>
    </v-container>
</template>

<script>
    import store from "../store/store";
    import Api from "../services/Api";
    import ApiBrevo from "../services/ApiBrevo";
    import PushInDataLayer from "../services/TagManager";
    import dayjs from "dayjs";


    import FaqSection from './apropos_component/faq_section_desktop.vue'
    import FaqSectionMobile from './apropos_component/faq_section_mobile.vue'
    import StatSection from './apropos_component/stats_section.vue'
    import StatSectionMobile from './apropos_component/stats_section_mobile.vue'

    export default {
        components: {
            FaqSection,
            FaqSectionMobile,
            StatSection,
            StatSectionMobile
        },
        data () {
            return {
                dialog : false,
                dialog2 : false,
                description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
                HideDive:true,
                HideDive1:false,
                HideDive2:false,
                tabs: null,
                isHidden : true,
                UserEmail: null,
                ToastTabSucess: { // Customized options for success toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 7000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                },
                ToastTabError: { // Customized options for error toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 7000,
                    fitToScreen: true,
                    type: 'error'
                },
            }
        },
        metaInfo () {
            return {
                meta: [
                    { charset: 'utf-8' },
                    { name: 'keywords', content: 'Apropos'},
                    { hid: 'description', name: 'description', content: this.description}
                ]
            }
        },
        methods :{
             /* Gestion de la video en francais */
    VideoManager: function () {
      let video = this.$refs.theVideo;
      this.dialog = false;
      if (video.played) {
        video.pause()
      }
    },

    /* Gestion de la video en wolof */
    VideoManagerWolof: function () {
      let video = this.$refs.theVideoWolof;
      this.dialog2 = false;
      if (video.played) {
        video.pause()
      }
    },

    /* lance la video en wolof */
    switchToWolof: function () {
      let video = this.$refs.theVideo;
      this.dialog = false;
      if (video.played) {
        video.pause()
      }
      this.dialog2 = true;
      let videoSn = this.$refs.theVideoWolof;
      videoSn.play()
    },

    /* Lance la video en francais*/
    switchToFrench: function () {
      let video = this.$refs.theVideoWolof;
      this.dialog2 = false;
      if (video.played) {
        video.pause()
      }
      this.dialog = true;
      let videoFr = this.$refs.theVideo;
      videoFr.play()
    },
            // fetchEventsList() {

            //     if (this.DevisCountTemp >= 10000) {
            //         if (this.DevisCountTemp < this.CountDevis) {
            //             this.DevisCountTemp = this.DevisCountTemp + 100
            //         }
            //         if (this.CountpartnersTemp < this.Countpartners) {
            //             this.CountpartnersTemp = this.CountpartnersTemp + 1
            //         }
            //     } else {
            //         if (this.DevisCountTemp < this.CountDevis) {
            //             this.DevisCountTemp = this.DevisCountTemp + 10
            //         }
            //         if (this.CountpartnersTemp < this.Countpartners) {
            //             this.CountpartnersTemp = this.CountpartnersTemp + 1
            //         }
            //     }

            // },

            
            suscribeNewsletter221 () {
        if(this.UserEmail) {
          let newAbonne221 = {
            listIds: [23],
            email: this.UserEmail,
            updateEnabled: false
          }

          ApiBrevo().post('contacts', newAbonne221)
            .then(result => {
              console.log("result===== ", result)

              if (result.status === 201) {
                this.$toasted.show("Merci de votre inscription à notre newsletter 221 !", this.ToastTabSucess);
                this.UserEmail = ''
              }
            }).catch((err) => {
              console.log("err==== ", err)
              this.$toasted.show("Le mail saisit est déja inscrit dans notre newsletter", this.ToastTabError);
            }); 
        } else {
          this.$toasted.show("Un email valide est obligatoire pour souscrire à notre newsletter 221 !", this.ToastTabError);
        }        
        },

            abonnementnewsletter() {
                if (this.UserEmail) {
                    if (store.state.isUserLoggedIn) {
                        let newAbonne = {
                            user: this.$store.state.user._id,
                            etat: 'enabled',
                            FNAME: this.$store.state.user.prenom,
                            LNAME: this.$store.state.user.nom,
                            PHONE: this.$store.state.user.telephone_port,
                            email: this.UserEmail,
                            dateAbone: dayjs(new Date()).format('YYYY-MM-DD')
                        };

                        Api().post('testimonial/mailchimp/newsletter', newAbonne)
                            .then(res => {
                                if (res.data.ret.statusCode == 200) {
                                    Api().post('newsletter/add', newAbonne)
                                        .then(resp => {
                                            if (resp.data.msg)
                                            {
                                                const GtmVal = {
                                                    event:'newsletter_subscription'
                                                }
                                                PushInDataLayer(GtmVal)
                                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                                this.UserEmail = ''
                                            }
                                        })
                                }
                            })
                            .catch(e => {
                                this.$toasted.show('Votre demande de souscription à la newsletter a échoué ', this.ToastTabError)
                            })

                    } else {

                        let newAbonne = {
                            user: "",
                            etat: 'enabled',
                            FNAME: "",
                            LNAME: "",
                            PHONE: "",
                            email: this.UserEmail,
                            dateAbone: dayjs(new Date()).format('YYYY-MM-DD')
                        };

                        Api().post('testimonial/mailchimp/newsletter', newAbonne)
                            .then(res => {
                                if (res.data.ret.statusCode == 200) {
                                    Api().post('newsletter/add', newAbonne)
                                        .then(resp => {
                                            if (resp.data.msg)
                                            {
                                                const GtmVal = {
                                                    event:'newsletter_subscription'
                                                }
                                                PushInDataLayer(GtmVal)
                                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                                this.UserEmail = ''
                                            }
                                        })
                                }

                            }).catch(e => {
                            this.$toasted.show('Votre demande de souscription à la newsletter a échoué', this.ToastTabError)
                        })
                    }

                } else {
                    this.$toasted.show('Veuillez renseigner votre adresse email ', this.ToastTabError)
                }
            },
            isMobile: function(){
                if (screen.width <= 760) {
                    return true;
                }
                else {
                    return false;
                }
            },
            isDesktop: function(){
                if (screen.width > 760) {
                    return true;
                }
                else {
                    return false;
                }
            },
            tabengclicked : function () {
                this.HideDive=false;
                this.HideDive1=true;
                this.HideDive2=false;
            },
            tabinovclicked  : function () {
                this.HideDive=true;
                this.HideDive1=false;
                this.HideDive2=false;
            },
            tabresclicked : function () {
                this.HideDive=false;
                this.HideDive1=false;
                this.HideDive2=true;
            },
            toggle : function () {
                this.isHidden = !this.isHidden;
                if (this.isHidden===false){
                    this.$refs.btnPlus.$el.innerText = 'Voir Moins';
                }else if (this.isHidden===true){
                    this.$refs.btnPlus.$el.innerText = 'Voir Plus';
                }
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            //this.Get_Followers_Count();
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/less/config";

    .underline_bar{
        height:4px;
        width: 150px;
        background:#ffa409;
    }
    .underline_bar_for_number{
        height:4px;
        width: 150px;
        background:#fff;
    }
    .titre_for_desktop{
        color: #2b2b2b;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
    }

    .v-tabs__item--active{
        color: #ffa409;
    }
    .mamadou{
        width: 145px;
        height: 600px;
    }
    .article{
        padding: 1%;
        text-align: justify;
        font-size: 16px;
        line-height: 30px;
        font-family: "Myriad Pro Regular" !important;
    }
    .img-box{
        width: 10%;
        height: 15%;
    }
    .text-sm-left{
        font-family: "Open-Sans" !important;
        font-size: 16px;
        padding: 2%;
        width: 498px;
    }
    .text-xs-right{
        font-family: "Open-Sans" !important;
        padding: 2%;
        padding-top: -1000px;
        margin-left: 700px;
        font-size: 16px;
        width: 498px;
    }
    /*notre equipe*/
    h2 {
        color: #333;
        text-align: center;
        text-transform: uppercase;
        font-family: "Open-Sans", sans-serif;
        font-weight: bold;
        position: relative;
        margin: 30px 0 60px;
    }
    .valeur .description{
        font-size: 14px;
        color: #FFFFFF;
        line-height: 26px;
        text-indent: 30px;
        position: relative;
        margin-top: -29px;
        margin-left: 450px;
    }
    .primary--text{
        font-family: Georgia;
        font-weight: bold;
        color: #000000;
        font-size: 20px;
    .v-tabs__item .v-tabs__item--active{
        color : black;
    }
    }
    .col-center {
        margin: 0 auto;
        float: none !important;
    }
    .carousel {
        margin: 50px auto;
        padding: 0 70px;
    }
    .carousel .item {
        color: #999;
        font-size: 14px;
        text-align: center;
        overflow: hidden;
    }
    .carousel .item .img-box {
        width: 175px;
        height: 175px;
        margin: 0 auto;
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 50%;
    }
    .carousel .img-box img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
    }
    .carousel .testimonial {
        padding: 30px 0 10px;
    }
    .carousel .overview {
        font-style: italic;
    }
    .carousel .overview b {
        text-transform: uppercase;
        color: #7AA641;
    }
    .carousel .carousel-control {
        width: 40px;
        height: 40px;
        margin-top: -20px;
        top: 50%;
        background: none;
    }
    .carousel-control i {
        font-size: 68px;
        line-height: 42px;
        position: absolute;
        display: inline-block;
        color: rgba(0, 0, 0, 0.8);
        text-shadow: 0 3px 3px #e6e6e6, 0 0 0 #000;
    }
    .carousel .carousel-indicators {
        bottom: -40px;
    }
    .carousel-indicators li, .carousel-indicators li.active {
        width: 10px;
        height: 10px;
        margin: 1px 3px;
        border-radius: 50%;
    }
    .carousel-indicators li {
        background: #999;
        border-color: transparent;
        box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
    }
    .carousel-indicators li.active {
        background: #555;
        box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
    }
    .border-radius{
        border-radius: 10px
    }
    .georgia{
        font-family: Georgia!important;
    }

/* =================== CSS TEAM ASSURAF AVEC CLICK POUR AGRANDIR PHOTO =================== */
/* =================== CSS TEAM ASSURAF AVEC CLICK POUR AGRANDIR PHOTO =================== */
/* =================== CSS TEAM ASSURAF AVEC CLICK POUR AGRANDIR PHOTO =================== */
a {
	color: #fff;
	text-decoration: none;
}
.animation {
	-webkit-transition: .5s ease-in-out;
	-moz-transition: .5s ease-in-out;
	-ms-transition: .5s ease-in-out;
	-o-transition: .5s ease-in-out;
	transition: .5s ease-in-out;
}
.lightboxClose {
	display: block;
	position: absolute;
	width: 100%;
	height: 100%;
}

/* ========== iframe Desktop===========*/
/* ========== iframe Desktop===========*/
/* ========== iframe Desktop===========*/
a.thumbnail img {
	padding: 5px;
	border: 6px solid white;
    border-radius: 10%;
    width: 70%;
    height: 180px;
    display: inline-block
}
.lightbox {
	display: block;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, .5);
	visibility: hidden;
	opacity: 0;
}
.lightbox img, .lightbox iframe {
    margin: auto;
    padding:5px;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	max-width: 50%;
	max-height: 70%;
	border: 6px solid white;
    box-sizing: border-box;
}
.lightbox:target {
	visibility: visible;
	opacity: 1;
}
.lightbox:target img, .lightbox:target iframe {
	max-width: 40%;
	max-height: auto;
}
/* ============================== Fin iframe Desktop ==============================*/

/* ========== iframe Mobile===========*/
/* ========== iframe Mobile===========*/
/* ========== iframe Mobile===========*/
a.thumbnail-mobile img {
	padding: 5px;
	border: 6px solid white;
    border-radius: 10%;
    width: 90%;
    height: 180px;
    display: inline-block
}
.lightbox-mobile {
	display: block;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, .5);
	visibility: hidden;
	opacity: 0;
}
.lightbox-mobile img, .lightbox-mobile iframe {
    margin: auto;
    padding:5px;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	max-width: 50%;
	max-height: 50%;
	border: 6px solid white;
    box-sizing: border-box;
}

.lightbox-mobile:target {
	visibility: visible;
	opacity: 1;
}
.lightbox-mobile:target img, .lightbox-mobile:target iframe {
	max-width: 95%;
    max-height: auto;
}
/* ================================ Fin iframe Mobile ===============================*/
    .titlePolice {
        font-family: Merriweather, Georgia, serif;
        font-weight: 300;
        //color: rgb(74, 74, 74);
    }

    .policeLato{
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }

















    .expansion.expand-list{
        margin: 0;
        padding: 0;
    }
    .expansion.expand-list > li{
        list-style-type: none;
        padding: 15px 0;
        background-color: #fff;
        border-radius: 10px;
        position: relative;
        margin-top: 10%;
        /*         max-width: 80%; */
    }
    .expansion label[class^="tab"]:hover{
        cursor: pointer;
    }
    .expansion input{
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    .expansion input[class^="tab"]{
        width: 100%;
        height: 40px;
        position: absolute;
        left: 0;
        top: 0;
    }
    .expansion input[class^="tab"]:hover{
        cursor: pointer;
    }
    .expansion label[class^="tab"]{
        font-weight: bold;
        font-size: 17px;
        margin-left: 3%;
    }
    .expansion .content{
        height: auto;
        max-height: 0;
        max-width: 400px;
        margin-left: 3%;
        font-weight: bold;
        /*        background: yellow;*/
        overflow: hidden;
        transform: translateY(20px);
        transition: all 180ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="100"] input[class^="tab"]:checked ~ .content{
        max-height: 100px;
        transition: all 150ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="200"] input[class^="tab"]:checked ~ .content{
        max-height: 200px;
        transition: all 200ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="300"] input[class^="tab"]:checked ~ .content{
        max-height: 300px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="400"] input[class^="tab"]:checked ~ .content{
        max-height: 400px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="500"] input[class^="tab"]:checked ~ .content{
        max-height: 500px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="600"] input[class^="tab"]:checked ~ .content{
        max-height: 600px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="700"] input[class^="tab"]:checked ~ .content{
        max-height: 700px;
        transition: all 300ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="800"] input[class^="tab"]:checked ~ .content{
        max-height: 800px;
        transition: all 300ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="900"] input[class^="tab"]:checked ~ .content{
        max-height: 900px;
        transition: all 300ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="1000"] input[class^="tab"]:checked ~ .content{
        max-height: 1000px;
        transition: all 350ms ease-in-out 0ms;
    }
    .expansion li[data-md-content=""] input[class^="tab"]:checked ~ .content{
        max-height: 1000px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion input[class^="tab"]:checked ~ .content{
        margin-bottom: 20px;
    }

    .expansion .open-close-icon{
        display: inline-block;
        position: absolute;
        right: 20px;
        transform: translatey(2px);
    }
    .expansion .open-close-icon i{
        position: absolute;
        left: 0;
    }
    .expansion .open-close-icon .fa-chevron-up{
        transform:rotate(-180deg);
        transition: transform 150ms ease-in-out 0ms;
    }
    .expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-up{
        opacity: 1;
        transform: rotate(0deg);
        transition: transform 150ms ease-in-out 0ms;
    }
    .expansion .open-close-icon .fa-chevron-down{
        opacity: 0;
        transform:rotate(-90deg);
        transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
    }
    .expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-down{
        opacity: 0;
        transform: rotate(0deg);
        transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
    }




    .trigger_auto{
        width: 270px;
    }
    .trigger_auto span {
        width: 270px;
        font-weight: bold;
        letter-spacing: 0px;
        font-size: 16px;
        position: relative;
        background: #ffa409;
        color: #000000;
        display: block;
        min-width: 0px;
        height: 50px;
        padding: 0 18px;
        z-index: 1;
        cursor: pointer;
        border-radius: 10px;
        transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }


    .newsletter span{
        width: 200px;
        font-weight: bold;
        letter-spacing: 0px;
        font-size: 16px;
        position: relative;
        text-transform: none;
        color: #000000;
        display: block;
        min-width: 0px;
        height: 50px;
        padding: 0 18px;
        z-index: 1;
        cursor: pointer;
        border: 2px solid #000000;
        border-radius: 10px;
        transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }
    .newsletter:hover span {
        //min-width: 220px;
        border-radius: 10px;
        border: none;
        transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
        color: #000000;
        background: #ffa409;
    }


    input[type="email"]{
        background: rgba(255, 255, 255, 0.1);
        border: none;
        font-size: 16px;
        height: auto;
        margin: 0;
        outline: 0;
        padding: 15px;
        width: 300px;
        background-color: rgba(115, 115, 115, 0.58);
        color: #fff;
        border-radius: 10px;
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
        margin-bottom: 30px;
    }
    input[type="email"]::placeholder{
        color: #fff;
        font-size: 20px;
    }


.trigger {
  width: 240px;
}

.trigger span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger:hover ul.devis {
  transform: scaley(1);
}

.trigger:hover ul.devis a {
  opacity: 1;
}





.trigger-simulation {
  width: 240px;
}

.trigger-simulation span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #5B94BC;
  color: #000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger-simulation ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger-simulation ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger-simulation ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger-simulation ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger-simulation ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger-simulation ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger-simulation ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger-simulation:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger-simulation:hover ul.devis {
  transform: scaley(1);
}

.trigger-simulation:hover ul.devis a {
  opacity: 1;
}



    .paralax-cover-image {
        background-image: url('../assets/img/apropos/a-propos.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 230px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 40px;
    }


    .paralax-cover-image_mobile {
        background-image: url('../assets/img/apropos/a_propos_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        //padding: 20px;
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        // background-attachment: fixed;
        background-position: 100% 40px;
    }


    .hero {
        position: relative;
        background-size: cover;
        background-position: center center;
        height: 680px;
        min-height: 320px;
        max-height: 100%;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        padding: 20px;
    }
    .hero .content_home {
        position: relative;
        min-height: 280px;
        width: 100%;
        margin-left: 8.5%;
        z-index: 2;
        /*//background: red;*/
    }
    .hero .content_home p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        width: 100%;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
</style>
